import { createSlice} from '@reduxjs/toolkit';
import { apiCallBegan } from './api';
import _ from 'lodash';
import { getFlightStatus } from '../components/flights/flightFunctions'
import { movePaxSameDay, movePaxDifDay } from "./dcsStoreFuncs";
// import moment from 'moment';

// TODO // Figure out how to break down the store into separate parts
const applyFilters = (filters, items) => {
  // NOTE // items are departures, filtersArr is an array of objs with filter type and their values
  let filteredItems = _.cloneDeep(items)
  let filtersArr = _.cloneDeep(filters)
  let paxFilters = ['rloc', 'passenger']
  // NOTE // loop over filters
  for (let i = 0; i < filtersArr.length; i++) {
    const filter = filtersArr[i];
    if (filter.value && filter.type === 'status') {
      filteredItems = filteredItems.filter(item => filter.value.includes(getFlightStatus(item, true)))
    }
    else if (filter.value && filter.value !== 'None') {
      if (!paxFilters.includes(filter.type)) {
        filteredItems = filteredItems.filter(item => item[filter.type] === filter.value)
      }
      // NOTE // rloc and passenger filters are looking through PaxList to find matches
      else {
        filteredItems = filteredItems.filter(item => item.PaxList.includes(filter.value))
      }
    }
  }
  return filteredItems
}

const formatFlightDate = (date) => {
  // NOTE // output: 17AUG2021, input: 2021-08-17
  let day = date.slice(8, 10)
  let month = date.slice(5, 7)
  let year = date.slice(0, 4)
  let monthsArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  month = monthsArr[Number(month) - 1]
  return `${day + month + year}`
}

function pad(num) {
  return num < 10 ? '0' + num : num;
}
let curDate = new Date()
let formattedDate = `${curDate.getFullYear()}-${pad(curDate.getMonth() + 1)}-${pad(curDate.getDate())}`

const slice = createSlice({
  name: 'dcs',
  initialState: {
    airline: '',
    list: [],
    movePaxList: [],
    loading: true,
    departureDate: formattedDate,
    tailNumber: 'None',
    flightNumber: 'None',
    origin: 'None',
    destination: 'None',
    status: ['Active'],
    passenger: '',
    rloc: '',
    filteredDeps: [],
    messageStatus: null,
    sendText: null,
    textResults: [],
    history: [],
    remarks: [],
    newTexts: [],
    showFilter: false,
    // NOTE // '' is not-sending, null is sending, true is success, false is failure. checkIn and noShow don't need statuses
    editPaxStatus: [{type: 'addRemark', status: ''}, {type: 'editWeight', status: ''}, {type: 'editPhone', status: ''}, {type: 'addApfax', status: ''}],
    // NOTE // null (not active), loading, success, and failure are the different values for movePaxStatus
    movePaxStatus: null
  },

  reducers: {
    setAirline: (state, action) => {
      state.airline = action.payload
    },

    setShowFilter: (state, action) => {
      state.showFilter = action.payload
    },

    departuresRequested: (state, action) => {
      state.loading = true;
    },

    departuresReceived: (state, action) => {
      // NOTE // sometimes requests are received out of order, so check the dates to make sure the right data is saved to the state
      if (action.payload.date === formatFlightDate(state.departureDate) || action.payload.date === state.departureDate) {
        state.list = action.payload.dcs
        // NOTE // it's awful, but it works (forgive me father, for I have sinned). Applying filters here so that the changes to list are registered before filtering
        state.filteredDeps = applyFilters([{type: 'TailNumber',value: _.cloneDeep(state.tailNumber)},{type: 'FlightNumber', value: _.cloneDeep(state.flightNumber)}, {type: 'Origin',value: _.cloneDeep(state.origin)},{type: 'Destination',value: _.cloneDeep(state.destination)}, {type: 'passenger', value:_.cloneDeep(state.passenger)}, {type: 'rloc', value: _.cloneDeep(state.rloc)}, {type: 'status', value: _.cloneDeep(state.status)}], _.cloneDeep(state.list));
        state.loading = false;
      }
    },

    departuresRequestFailed: (state, action) => {
      console.error(`ERR: ${action.payload}`)
    },

    movePaxRequested: (state, action) => {
      state.movePaxStatus = 'loading'
    },

    movePaxDepsReceived: (state, action) => {
      state.movePaxList = action.payload.dcs
      state.messageStatus = false
    },

    movePaxDepsFailed: (state, action) => {
      console.error(`ERR: ${action.payload}`)
      state.messageStatus = false
    },

    setMovePaxDeps: (state, action) => {
      state.movePaxList = action.payload
    },

    movePaxDepsRequested: (state, action) => {
      state.messageStatus = true
    },

    resetMovePaxStatus: (state) => {
      state.movePaxStatus = null
    },

    saveMovePaxSuccess: (state, action) => {
      // NOTE // an array of any errors from moving the rlocs
      let resultErrorsArr = Array.isArray(action?.payload) ? action.payload.map(resObj => resObj?.error) : ['ERROR: payload is not an array']

      if (Array.isArray(action?.payload)) {
        // NOTE // a copy of the dcs list
        let listCopy = _.cloneDeep(state.filteredDeps)
        // NOTE // grab the first successful move to get the to flt num & date, and the from flt num & date
        let firstSuccess = action.payload.findIndex(resObj => resObj?.result && !resObj.error)
        if (firstSuccess !== -1) {
          // NOTE // Flight Number moved to (e.g. "TJ1006")
          let to = action.payload[firstSuccess].to.slice(0, 6)
          // NOTE // Flight Number moved from (e.g. "TJ1004")
          let from = action.payload[firstSuccess].from.slice(0, 6)
          // NOTE // date format DDMMM (e.g. 30Sep)
          let toDate = action.payload[firstSuccess].to.slice(7, 12)
          let fromDate = action.payload[firstSuccess].from.slice(7, 12)
          // NOTE // filter out results with errors so that those aren't moved (they could have still moved, but it's unlikely)
          let filteredResults = action.payload.filter(resObj => resObj?.result && !resObj.error)
          let rlocs = filteredResults.map(item => item.rloc)
          let newList = fromDate === toDate ? movePaxSameDay(listCopy, to, from, rlocs) : movePaxDifDay(listCopy, from, rlocs)
  
          // NOTE // set the changes to the state
          state.filteredDeps = newList
          state.list = newList
        }
      }
      // NOTE // if there are no errors, set the movePaxStatus to 'success', otherwise set it to 'failure'
      if (Array.isArray(action?.payload) && !(resultErrorsArr.join('').length > 1)) {
        state.movePaxStatus = 'success'
      }
      else {
        state.movePaxStatus = 'failure'
      }
    },

    saveMovePaxFailure: (state, action) => {
      let result = action?.payload?.result
      console.error(result ? result : 'Error moving pax: bad result')
      state.movePaxStatus = 'failure'
    },

    resetMovePaxList: (state, action) => {
      state.movePaxList = []
    },

    changePaxStatusSuccess: (state, action) => {
      let payload = action.payload
      let isSuccess = payload?.response?.includes('success')
      let paxNum = payload?.editData?.paxNumber
      let rloc = payload.rloc
      let listCopy = _.cloneDeep(state.filteredDeps)
      if (isSuccess && rloc && paxNum) {
        for (let i = 0; i < listCopy.length; i++) {
          const dep = listCopy[i];
          if (dep.passengers && dep.passengers.length) {
            let paxLoc = dep.passengers.findIndex(pax => pax.PNRRefNo === rloc && pax.PaxNumber === paxNum)
            if (paxLoc !== -1) {
              // NOTE // Idk why checkIn editData.newStatus is a bool while noShow editData.newStatus is the actual status lol
              if (payload.type === 'checkIn') {
                state.filteredDeps[i].passengers[paxLoc].ETStatus = payload.editData.newStatus === true ? "C" : "O"
                break
              }
              else if (payload.type === 'noShow') {
                state.filteredDeps[i].passengers[paxLoc].ETStatus = payload.editData.newStatus
                break
              }
            }
          }
        }
      }
    },

    changePaxStatusFailure: (state, action) => {
      console.log(`changePaxStatus ERROR: ${action.payload}`)
    },

    // SECTION DCS Index Filters (I know it's ugly. This was the frustrating conclusion to the filters)
    changeDepartureDate: (state, action) => {
      state.departureDate = action.payload
    },

    changeTailNumber: (state, action) => {
      state.tailNumber = action.payload
      state.filteredDeps = applyFilters([{type: 'TailNumber',value: _.cloneDeep(state.tailNumber)},{type: 'FlightNumber', value: _.cloneDeep(state.flightNumber)}, {type: 'Origin',value: _.cloneDeep(state.origin)},{type: 'Destination',value: _.cloneDeep(state.destination)}, {type: 'passenger', value:_.cloneDeep(state.passenger)}, {type: 'rloc', value: _.cloneDeep(state.rloc)}, {type: 'status', value: _.cloneDeep(state.status)}], _.cloneDeep(state.list))
    },

    changeFlightNumber: (state, action) => {
      state.flightNumber = action.payload
      state.filteredDeps = applyFilters([{type: 'TailNumber',value: _.cloneDeep(state.tailNumber)},{type: 'FlightNumber', value: _.cloneDeep(state.flightNumber)}, {type: 'Origin',value: _.cloneDeep(state.origin)},{type: 'Destination',value: _.cloneDeep(state.destination)}, {type: 'passenger', value:_.cloneDeep(state.passenger)}, {type: 'rloc', value: _.cloneDeep(state.rloc)}, {type: 'status', value: _.cloneDeep(state.status)}], _.cloneDeep(state.list))
    },

    changeOrigin: (state, action) => {
      state.origin = action.payload
      state.filteredDeps = applyFilters([{type: 'TailNumber',value: _.cloneDeep(state.tailNumber)},{type: 'FlightNumber', value: _.cloneDeep(state.flightNumber)}, {type: 'Origin',value: _.cloneDeep(state.origin)},{type: 'Destination',value: _.cloneDeep(state.destination)}, {type: 'passenger', value:_.cloneDeep(state.passenger)}, {type: 'rloc', value: _.cloneDeep(state.rloc)}, {type: 'status', value: _.cloneDeep(state.status)}], _.cloneDeep(state.list))
    },

    changeDestination: (state, action) => {
      state.destination = action.payload
      state.filteredDeps = applyFilters([{type: 'TailNumber',value: _.cloneDeep(state.tailNumber)},{type: 'FlightNumber', value: _.cloneDeep(state.flightNumber)}, {type: 'Origin',value: _.cloneDeep(state.origin)},{type: 'Destination',value: _.cloneDeep(state.destination)}, {type: 'passenger', value:_.cloneDeep(state.passenger)}, {type: 'rloc', value: _.cloneDeep(state.rloc)}, {type: 'status', value: _.cloneDeep(state.status)}], _.cloneDeep(state.list))
    },

    changePassenger: (state, action) => {
      state.passenger = action.payload
      state.filteredDeps = applyFilters([{type: 'TailNumber',value: _.cloneDeep(state.tailNumber)},{type: 'FlightNumber', value: _.cloneDeep(state.flightNumber)}, {type: 'Origin',value: _.cloneDeep(state.origin)},{type: 'Destination',value: _.cloneDeep(state.destination)}, {type: 'passenger', value:_.cloneDeep(state.passenger)}, {type: 'rloc', value: _.cloneDeep(state.rloc)}, {type: 'status', value: _.cloneDeep(state.status)}], _.cloneDeep(state.list))
    },

    changeRloc: (state, action) => {
      state.rloc = action.payload
      state.filteredDeps = applyFilters([{type: 'TailNumber',value: _.cloneDeep(state.tailNumber)},{type: 'FlightNumber', value: _.cloneDeep(state.flightNumber)}, {type: 'Origin',value: _.cloneDeep(state.origin)},{type: 'Destination',value: _.cloneDeep(state.destination)}, {type: 'passenger', value:_.cloneDeep(state.passenger)}, {type: 'rloc', value: _.cloneDeep(state.rloc)}, {type: 'status', value: _.cloneDeep(state.status)}], _.cloneDeep(state.list))
    },

    changeStatus: (state, action) => {
      state.status = action.payload
      state.filteredDeps = applyFilters([{type: 'TailNumber',value: _.cloneDeep(state.tailNumber)},{type: 'FlightNumber', value: _.cloneDeep(state.flightNumber)}, {type: 'Origin',value: _.cloneDeep(state.origin)},{type: 'Destination',value: _.cloneDeep(state.destination)}, {type: 'passenger', value:_.cloneDeep(state.passenger)}, {type: 'rloc', value: _.cloneDeep(state.rloc)}, {type: 'status', value: _.cloneDeep(state.status)}], _.cloneDeep(state.list))
    },
    // !SECTION
    // SECTION General message status actions
    resetMessageStatus: (state, action) => {
      state.messageStatus = null
    },

    startSendText: (state, action) => {
      state.textResults = 'sending'
    },

    sendTextSuccess: (state, action) => {
      state.textResults = action.payload
    },

    sendTextFailure: (state, action) => {
      state.textResults = 'failure'
    },

    resetTextResults: (state, action) => {
      state.textResults = []
    },

    generalSendingMsg: (state, action) => {
      state.messageStatus = 'Sending...';
      state.sendText = `Sending...`
    },

    generalReceivedMsg: (state, action) => {
      state.messageStatus = 'Success';
      state.sendText = `Success`
    },

    generalFailureMsg: (state, action) => {
      console.error(action.payload)
      state.messageStatus = 'Failure';
      state.sendText = `Failure`
    },

    generalSending: (state, action) => {
      state.messageStatus = 'Loading'
    },

    generalSuccess: (state, action) => {
      state.messageStatus = 'Success!'
    },

    generalFailure: (state, action) => {
      state.messageStatus = 'Failure'
      console.error(action.payload)
    },

    historyFetching: (state, action) => {
      // state.loading = true;
      state.sendText = null;
    },

    historyReceived: (state, action) => {
      state.history = action.payload
    },

    historyFailure: (state, action) => {
      console.error(action.payload)
    },

    newTextsReceived: (state, action) => {
      state.newTexts = action.payload
    },

    getRemarksSuccess: (state, action) => {
      state.remarks = action.payload;
    },

    resetRemarks: (state, action) => {
      state.remarks = []
    },

    resetTextHistory: (state, action) => {
      state.history = [];
    },

    // NOTE // changing the editPaxStatus so show that a request is sending
    // NOTE // editPhone and editWeight use an object to set rloc and paxNum for the InlineEdit to use
    sendingEditPax: (state, action) => {
      let payload = action.payload
      let payloadType = typeof payload
      let type = payloadType === 'string' ? payload : payload.type
      let editStatusLoc = _.cloneDeep(state.editPaxStatus).findIndex(obj => obj.type === type)
      state.editPaxStatus[editStatusLoc].status = null
      if (payloadType === 'object') {
        state.editPaxStatus[editStatusLoc].rloc = payload.rloc
        state.editPaxStatus[editStatusLoc].paxNum = payload.paxNum
      }
    },

    // NOTE // changes the status for each edit, and changes the state list if necessary
    editPaxReceived: (state, action) => {
      // NOTE // success-response: {response: response, type: type, rloc: rloc, editData: editData} 
      // NOTE // failure-response: {response: response, type: type}
      let res = _.cloneDeep(action.payload)
      // NOTE // checkIn and noShow don't have a status (addRemark, editWeight, editPhone, and addApfax are the ones left)
      if (res.type !== 'checkIn' && res.type !== 'noShow') {
        let statusCopy = _.cloneDeep(state.editPaxStatus)
        let listCopy = _.cloneDeep(state.filteredDeps)
        // NOTE // getting the status object loc (status object example: {type: 'addApfax', status: ''})
        let statusLoc = statusCopy.findIndex(obj => obj.type === res.type)
        if (res?.response?.includes('success')) {
          // NOTE // change the status to true for success
          state.editPaxStatus[statusLoc].status = true
          // NOTE // don't need to change anything aside from status for addRemark
          if (res.type !== 'addRemark') {
            // NOTE // find all flights that have passengers with a matching rloc
            let flightsToEdit = _.cloneDeep(listCopy).filter(flt => flt.passengers && flt.passengers.findIndex(pax => pax.PNRRefNo === res.rloc) !== -1)
            let editedFlights = []

            for (let i = 0; i < flightsToEdit.length; i++) {
              const curFlight = flightsToEdit[i];
              let fltCopy = _.cloneDeep(curFlight)
              // NOTE // find the pax that was modified (has paxNumber: phone & weight /// could have paxNumber: apfax)
              if (res.editData.paxNumber) {
                let paxLoc = fltCopy.passengers.findIndex(pax => pax.PNRRefNo === res.rloc && pax.PaxNumber === res.editData.paxNumber)
                let pax = paxLoc !== -1 ? fltCopy.passengers[paxLoc] : ''
                // NOTE // change the pax that was modified
                if (pax) {
                  if (res.type.toUpperCase().includes('PHONE')) {
                    fltCopy.passengers[paxLoc].phone = res.editData.phoneNumber
                  }
                  else if (res.type.toUpperCase().includes('WEIGHT')) {
                    fltCopy.passengers[paxLoc].Weight = res.editData.weight
                  }
                  else {
                    fltCopy.passengers[paxLoc][res.editData.fact] = '1'
                  }
                }
              }
              // NOTE // no paxNumber at this point just leaves adding a fact to all pax with a matching rloc
              else {
                for (let j = 0; j < curFlight.passengers.length; j++) {
                  const pax = curFlight.passengers[j];
                  if (pax.PNRRefNo === res.editData.rloc) {
                    fltCopy.passengers[j][res.editData.fact] = '1'
                  }
                }
              }
              // NOTE // add the modified flight to editedFlights
              editedFlights.push(fltCopy)
            }

            // NOTE // change all the edited flights in the state
            for (let i = 0; i < editedFlights.length; i++) {
              const newFlt = editedFlights[i];
              let newFltLoc = listCopy.findIndex(flt => flt.FlightNumber === newFlt.FlightNumber)
              listCopy[newFltLoc] = _.cloneDeep(newFlt)
            }
            state.filteredDeps = listCopy
          }
        }
        else {
          state.editPaxStatus[statusLoc].status = false
        }
      }
    },

    resetEditPaxStatus: (state, action) => {
      state.editPaxStatus = [{type: 'addRemark', status: ''}, {type: 'editWeight', status: ''}, {type: 'editPhone', status: ''}, {type: 'addApfax', status: ''}]
    }
  }
})

const {
  departuresReceived, departuresRequested, departuresRequestFailed, startSendText, sendTextSuccess, sendTextFailure, generalSendingMsg, generalSending,
  movePaxDepsReceived, movePaxDepsFailed, movePaxRequested, saveMovePaxSuccess, saveMovePaxFailure, movePaxDepsRequested, changePaxStatusSuccess, changePaxStatusFailure, historyFetching, historyReceived, historyFailure, 
  newTextsReceived, getRemarksSuccess, generalSuccess, generalFailure, sendingEditPax, editPaxReceived
} = slice.actions;

// NOTE // api actions
export const { setAirline, setShowFilter, changeDepartureDate, changeDestination, changeFlightNumber, changeOrigin, changePassenger, changeRloc, changeTailNumber, setFilteredDepartures, clearMovePaxDeps, setMovePaxDeps, resetMessageStatus, resetEditPaxStatus, resetRemarks, resetTextHistory, resetTextResults, changeStatus, resetMovePaxStatus, resetMovePaxList } = slice.actions;
export default slice.reducer;
export const loadDepartures = (departureDate, departureAirport) => (dispatch, getState) => {
  const url = `getDcs`;

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {date: departureDate, airlineId: getState().entities.dcs.airline},
      onStart: departuresRequested.type,
      onSuccess: departuresReceived.type,
      onError: departuresRequestFailed.type,
    })
  )
}

export const loadMovePaxDeps = (depDate) => (dispatch, getState) => {
  const url = `getDcs`;

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {date: depDate, airlineId: getState().entities.dcs.airline},
      onStart: movePaxDepsRequested.type,
      onSuccess: movePaxDepsReceived.type,
      onError: movePaxDepsFailed.type,
    })
  )
}

// const payload = {airlineId: req.body.airlineId, rlocs: req.body.rlocs, from: req.body.from, to: req.body.to}
export const saveMovePaxChanges = (rlocs, from, to) => (dispatch, getState) => {
  const url = `movePax`
  // NOTE // backend expects
  // from: from, // TJ1002/25Aug
  // to: to, // TJ1000/25AUG21/HPN/ACK

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {airlineId: getState().entities.dcs.airline, rlocs: rlocs, from: from, to: to},
      onStart: movePaxRequested.type,
      onSuccess: saveMovePaxSuccess.type,
      onError: saveMovePaxFailure.type,
    })
  )
}

// NOTE // this is for editing-pax: phone and weight, and adding: remarks and apfax
export const editPax = (data) => (dispatch, getState) => {
  const url = `editPaxData`
  data.airlineId = getState().entities.dcs.airline
  // NOTE // dispatching here instead of onStart to pass in the type and (if it's phone/weight) passenger info
  // NOTE // the rloc and paxNumber are for InlineEdit to pass the status to the correct pax
  if(data.type === 'editPhone' || data.type === 'editWeight') {
    dispatch(sendingEditPax({type: data.type, rloc: data.rloc, paxNum: data.editData.paxNumber}))
  }
  else {
    dispatch(sendingEditPax(data.type))
  }

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: data,
      onSuccess: editPaxReceived.type,
      onError: editPaxReceived.type,
    })
  )
}

export const changePaxStatus = (payload) => (dispatch, getState) => {
  const url = `editPaxData`
  // TODO // probably want to move or change where the airlineId is being used later 11/03/21
  payload.airlineId = getState().entities.dcs.airline

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: payload,
      onSuccess: changePaxStatusSuccess.type,
      onError: changePaxStatusFailure.type,
    })
  )
}

export const textPax = (message, pax) => (dispatch, getState) => {
  const url = `sms/send`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {message: message, airlineId: getState().entities.dcs.airline, passengers: pax},
      onStart: startSendText.type,
      onSuccess: sendTextSuccess.type,
      onError: sendTextFailure.type,
    })
  )
}

export const flightTextHistory = (date, flightNumber) => (dispatch, getState) => {
  const url = `sms-history`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {date, flightNumber, airlineId: getState().entities.dcs.airline},
      onStart: historyFetching.type,
      onSuccess: historyReceived.type,
      onError: historyFailure.type,
    })
  )
}

export const individualTextHistory = (phoneNumber) => (dispatch, getState) => {
  const url = `sms-history/individual`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {phoneNumber},
      onStart: historyFetching.type,
      onSuccess: historyReceived.type,
      onError: historyFailure.type,
    })
  )
}

// NOTE We also store texts we send in remarks of a pnr so while this may not be used its good to have
export const individualTextHistoryVidecom = (phoneNumber, rloc) => (dispatch, getState) => {
  const url = `sms/history/individual/videcom`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {phoneNumber, rloc, airlineId: getState().entities.dcs.airline},
      onStart: historyFetching.type,
      onSuccess: historyReceived.type,
      onError: historyFailure.type,
    })
  )
}

export const fetchNewTexts = () => (dispatch, getState) => {
  const url = `sms/newTexts`

  return dispatch(
    apiCallBegan({
      url,
      method: 'get',
      onStart: historyFetching.type,
      onSuccess: newTextsReceived.type,
      onError: historyFailure.type,
    })
  )
}

export const fetchRemarks = (rloc) => (dispatch, getState) => {
  const url = `getDcs/remarks`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {rloc, airlineId: getState().entities.dcs.airline},
      onSuccess: getRemarksSuccess.type,
      onError: getRemarksSuccess.type,
    })
  )
}

export const markTextsAsOld = (ids) => (dispatch, getState) => {
  const url = `sms/markOld`

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: {ids},
      // onStart: ,
      onSuccess: generalSuccess.type,
      onError: generalFailure.type,
    })
  )
}

export const editFlight = (data) => (dispatch, getState) => {
  const url = `editFlightData`
  data.airlineId = getState().entities.dcs.airline
  data.editData.airlineId = data.airlineId

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      data: data,
      onStart: generalSending.type,
      onSuccess: generalSuccess.type,
      onError: generalFailure.type,
    })
  )
}